import { createSlice } from "@reduxjs/toolkit";
import {
  addMediaToInstagram,
  deleteComment,
  fetchIgConversations,
  getCommentReplies,
  getIgConversationByUser,
  getIgstories,
  getPostComments,
  hideUnhideComment,
  igautochat,
  igDisconnect,
  IghandleLogoutAndReLogin,
  igProfile,
  insertPostComment,
  instagramsendmessage,
  publishMediaOnInstagram,
  replyToComment,
  toggleMediaComments,
} from "./instagramThunk";
import actions from "../setting/actions";

const instagramSlice = createSlice({
  name: "instagram",
  initialState: {
    conversations: [],
    conversationDetails: {},
    loading: false,
    igloading: false,
    error: null,
    message: null,
    profile: {},
    Comments: [],
    commentReplies: {}, // stores replies for each comment
    Disconnectmessage: null,
    commentActions: {
      loading: false,
      error: null,
      success: null
    },
    igReLoginMessage: null,
    Igstoriessccsess: null,
    Igstorieserror: null,
    Igstoriespanding: false,

    deletecommentloading: false,
    deletecommenterror: null,
    deletecommentsuccess: null,

    replyToCommentloading: false,
    replyToCommenterror: null,
    replyToCommentsuccess: null,

    toggleMediaCommentssuccess: null,
    toggleMediaCommenterror: null,
    toggleMediaCommentspanding: false,
  },

  reducers: {
    resetigReLoginMessage: (state) => {
      state.igReLoginMessage = null;
    },
    clearCommentError: (state) => {
      state.commentActions.error = null;
    },
    clearCommentSuccess: (state) => {
      state.commentActions.success = null;
    },
    resetCommentActions: (state) => {
      state.commentActions = {
        loading: false,
        error: null,
        success: null
      };
    }

  },
  extraReducers: (builder) => {
    builder

      .addCase(fetchIgConversations.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchIgConversations.fulfilled, (state, action) => {
        state.conversations = action.payload;
        state.loading = false;
      })
      .addCase(fetchIgConversations.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(getIgConversationByUser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getIgConversationByUser.fulfilled, (state, action) => {
        state.conversationDetails = action.payload;
        state.loading = false;
      })
      .addCase(getIgConversationByUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(igautochat.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(igautochat.fulfilled, (state, action) => {
        state.loading = false;
        state.message = action.payload;
      })
      .addCase(igautochat.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(instagramsendmessage.pending, (state) => {
        state.igSendMessageloading = true;
        state.error = null;
      })
      .addCase(instagramsendmessage.fulfilled, (state, action) => {
        state.igSendMessageloading = false;
        state.message = action.payload;
      })
      .addCase(instagramsendmessage.rejected, (state, action) => {
        state.igSendMessageloading = false;
        state.error = action.payload;
      })

      // Add Media to Instagram
      .addCase(addMediaToInstagram.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addMediaToInstagram.fulfilled, (state, action) => {
        state.loading = false;
        state.message = action.payload;
      })
      .addCase(addMediaToInstagram.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(publishMediaOnInstagram.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(publishMediaOnInstagram.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(publishMediaOnInstagram.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(insertPostComment.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(insertPostComment.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(insertPostComment.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(getCommentReplies.pending, (state) => {
        state.commentActions.loading = true;
        state.commentActions.error = null;
      })
      .addCase(getCommentReplies.fulfilled, (state, action) => {
        state.commentActions.loading = false;
        const { commentId, replies } = action.payload;
        state.commentReplies[commentId] = replies;
      })
      .addCase(getCommentReplies.rejected, (state, action) => {
        state.commentActions.loading = false;
        state.commentActions.error = action.payload;
      })

      .addCase(replyToComment.pending, (state) => {
        state.replyToCommentloading = true;
        state.replyToCommenterror = null;
      })
      .addCase(replyToComment.fulfilled, (state, action) => {
        state.replyToCommentloading = false;
        state.replyToCommentsuccess = action.payload.message;
      })
      .addCase(replyToComment.rejected, (state, action) => {
        state.replyToCommentloading = false;
        state.replyToCommenterror = action.payload;
      })

      .addCase(hideUnhideComment.pending, (state) => {
        state.hideUnhideCommentloading = true;
        state.hideUnhideCommenterror = null;
      })
      .addCase(hideUnhideComment.fulfilled, (state, action) => {
        state.hideUnhideCommentloading = false;
        state.hideUnhideCommentsuccess = action.payload.message;
      })
      .addCase(hideUnhideComment.rejected, (state, action) => {
        state.hideUnhideCommentloading = false;
        state.hideUnhideCommenterror = action.payload;
      })

      .addCase(toggleMediaComments.pending, (state) => {
        state.toggleMediaCommentsloading = true;
        state.toggleMediaCommentserror = null;
      })
      .addCase(toggleMediaComments.fulfilled, (state, action) => {
        state.toggleMediaCommentsloading = false;
        state.toggleMediaCommentssuccess = action.payload.message;
      })
      .addCase(toggleMediaComments.rejected, (state, action) => {
        state.toggleMediaCommentsloading = false;
        state.toggleMediaCommentserror = action.payload;
      })

      .addCase(deleteComment?.pending, (state) => {
        state.deletecommentloading = true;
        state.deletecommenterror = null;
      })
      .addCase(deleteComment?.fulfilled, (state, action) => {
        state.deletecommentloading = false;
        state.deletecommentsuccess = action.payload.message;

        // Remove deleted comment from state
        const { commentId } = action.payload;
        state.Comments.forEach(postComments => {
          if (postComments.comments?.data) {
            postComments.comments.data = postComments.comments.data.filter(
              comment => comment.id !== commentId
            );
          }
        })
      })
      .addCase(deleteComment?.rejected, (state, action) => {
        state.deletecommentloading = false;
        state.deletecommenterror = action.payload;
      })

      // Get Post Comments
      .addCase(getPostComments.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getPostComments.fulfilled, (state, action) => {
        state.loading = false;
        const { postId, comments } = action.payload;

        // Find if comments for this post already exist
        const existingCommentIndex = state.Comments.findIndex(
          (comment) => comment.postId === postId
        );

        if (existingCommentIndex !== -1) {
          // Update existing comments for this post
          state.Comments[existingCommentIndex] = {
            postId,
            comments
          };
        } else {
          // Add new comments for this post
          state.Comments.push({
            postId,
            comments
          });
        }

        console.log(
          state.Comments,
          "_______________ Updated state.Comments________________"
        );
      })
      .addCase(getPostComments.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Disconnect
      .addCase(igDisconnect.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(igDisconnect.fulfilled, (state, action) => {
        state.loading = false;
        state.Disconnectmessage = action.payload;
      })
      .addCase(igDisconnect.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(igProfile.pending, (state) => {
        state.igloading = true;
        state.error = null;
      })
      .addCase(igProfile.fulfilled, (state, action) => {
        state.profile = action.payload;
        state.igloading = false;
      })
      .addCase(igProfile.rejected, (state, action) => {
        state.igloading = false;
        state.error = action.payload;
      })
      .addCase(getIgstories.pending, (state) => {
        state.Igstoriespanding = true;
        state.Igstorieserror = null;
        state.Igstoriessccsess = null;
      })
      .addCase(getIgstories.fulfilled, (state, action) => {
        state.Igstoriessccsess = action.payload;
        state.Igstoriespanding = false;
      })
      .addCase(getIgstories.rejected, (state, action) => {
        state.Igstoriespanding = false;
        state.Igstorieserror = action.payload;
      })

      .addCase(IghandleLogoutAndReLogin.pending, (state) => {
        state.igloading = true;
        state.error = null;
      })
      .addCase(IghandleLogoutAndReLogin.fulfilled, (state, action) => {
        state.igReLoginMessage = action.payload;
        state.igloading = false; // Fixed: was using 'loading' instead of 'igloading'
      })
      .addCase(IghandleLogoutAndReLogin.rejected, (state, action) => {
        state.igloading = false; // Fixed: was using 'loading' instead of 'igloading'
        state.error = action.payload;
      });
  },
});

export const { logout, resetigReLoginMessage, clearCommentError, clearCommentSuccess, resetCommentActions } = instagramSlice.actions;

export default instagramSlice.reducer;